import { render, staticRenderFns } from "./GroupOfAccreditationItemBody.vue?vue&type=template&id=7a1ced95"
import script from "./GroupOfAccreditationItemBody.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationItemBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports